import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

const Props = {
    websites: PropTypes.arrayOf(
        PropTypes.shape({
            type: PropTypes.string,
            link: PropTypes.string
        })
    ).isRequired
};

const extractLabel = website => website.split('//')[1];
const isWithPipe = (length, index) => length !== index + 1;

const WebsitesLinks = ({ websites }) => (
    <Row className="speaker-links-wrapper">
        <Col className="speaker-links" lg={12}>
            {
                websites.map(({ type, link }, i, websites) => (
                    <Fragment key={`websites_links_${i}`}>
                        {type}: <a
                            href={link}
                            target="_blank"
                            className="custom-color color-1">
                            {extractLabel(link)}
                        </a>
                        {isWithPipe(websites.length, i) && ' | '}
                    </Fragment>
                )
                )
            }
        </Col>
    </Row>
);

WebsitesLinks.propType = Props;

export default WebsitesLinks;
